import { type Tier } from "@/ui/types";

// Human labels for the print tiers — the single source of truth (used on the product page, cart,
// and order confirmation so a variant always reads the same everywhere).
export const TIER_LABEL: Record<Tier, string> = {
	art_card: "Cabinet Print",
	open: "Open Edition",
	limited: "Limited Edition",
};

// Tier display order (small→large / entry→flagship).
export const TIER_ORDER: Tier[] = ["art_card", "open", "limited"];

// --- Fulfillment gating (TODO §E.6) --------------------------------------------------------------
// Sizes we cannot currently print in-house. 24×36 needs large-format / dropship printing, which
// isn't integrated yet — so these variants are hidden from the product page AND their price is
// excluded from the shop grid's displayed range (so we never advertise a size we can't fulfill).
// Remove entries here to re-enable once the dropship-vendor integration (§E.6/§E.5) lands.
export const HIDDEN_SIZES = new Set<string>(['24" x 36"']);

// The highest price (in cents) we can currently fulfill — the 16×24 limited at $500. Used to clamp
// the shop grid's price range so it doesn't show the hidden 24×36 ceiling. Keep in sync with pricing.
export const MAX_FULFILLABLE_CENTS = 50000;

// Full variant name, e.g. `5" x 7" · Cabinet Print`. Falls back gracefully if size/tier missing.
export function variantName(size: string | undefined, tier: Tier | undefined): string {
	const label = tier ? TIER_LABEL[tier] : undefined;
	if (size && label) return `${size} · ${label}`;
	return size || label || "";
}
